// combatpro/treasure/TreasureResult.js
//
// Presentational renderer for a generated/stored treasure result. Groups items by
// category, shows coins, per-item value, and the total. Inline per-item actions
// (reroll one, edit quantity, remove) and coins are driven by callbacks so the same
// renderer serves the fast monster modal and the full Treasure page. Read-only when
// no callbacks are supplied. No optional chaining, no em dash.

import React from 'react';
import { categoryLabel, formatValue, formatCoins } from './treasureFormat';

function TreasureResult(props) {
  var result = props.result;
  var currency = props.currency;
  var actions = props.actions || {};
  if (!result) { return null; }

  var items = result.items || [];
  var byCat = {};
  items.forEach(function (it) { if (!byCat[it.category]) { byCat[it.category] = []; } byCat[it.category].push(it); });
  var cats = Object.keys(byCat);
  var coinsStr = (result.coins && result.coins.value > 0) ? formatCoins(result.coins.counts, currency) : '';

  return (
    <div className="vi-tr-result">
      <div className="vi-tr-result-head">
        <span className="vi-tr-total-label">Total value</span>
        <span className="vi-tr-total-value">{formatValue(result.totalValue, currency)}</span>
      </div>

      {coinsStr ? (
        <div className="vi-tr-cat">
          <div className="vi-tr-cat-head"><span>{categoryLabel('coins')}</span><span className="vi-tr-cat-val">{formatValue(result.coins.value, currency)}</span></div>
          <div className="vi-tr-coins">{coinsStr}</div>
        </div>
      ) : null}

      {cats.length === 0 && !coinsStr ? <div className="vi-tr-empty">No items generated. Try Reroll, or widen the wealth / quantity.</div> : null}

      {cats.map(function (cat) {
        return (
          <div className="vi-tr-cat" key={cat}>
            <div className="vi-tr-cat-head"><span>{categoryLabel(cat)}</span></div>
            {byCat[cat].map(function (it, idx) {
              return (
                <div className="vi-tr-item" key={it.id + '_' + idx}>
                  <div className="vi-tr-item-main">
                    <span className="vi-tr-item-qty">{it.qty > 1 ? (it.qty + 'x ') : ''}</span>
                    <span className="vi-tr-item-name">{it.name}{it.magic ? ' ✨' : ''}</span>
                    {it.desc ? <span className="vi-tr-item-desc">{it.desc}</span> : null}
                  </div>
                  <div className="vi-tr-item-side">
                    {it.value ? <span className="vi-tr-item-val">{formatValue(it.value, currency)}</span> : null}
                    {actions.onRerollItem ? <button type="button" className="vi-tr-mini" title="Reroll this item" onClick={function () { actions.onRerollItem(it); }}>&#8635;</button> : null}
                    {actions.onEditItem ? <button type="button" className="vi-tr-mini" title="Edit" onClick={function () { actions.onEditItem(it); }}>&#9998;</button> : null}
                    {actions.onRemoveItem ? <button type="button" className="vi-tr-mini vi-tr-mini-danger" title="Remove" onClick={function () { actions.onRemoveItem(it); }}>&times;</button> : null}
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

export default TreasureResult;
